import React from 'react';

import './CenteredModalContent.scss';

export interface Props extends React.PropsWithChildren {
    withMessage?: boolean;
}

const CenteredModalContent: React.FC<Props> = ({ children, withMessage = false }) => {
    if (withMessage) {
        return (
            <div className="centered-modal-content__container">
                <section className="centered-modal-content__message">{children}</section>
            </div>
        );
    }
    return <section className="centered-modal-content">{children}</section>;
};

export default CenteredModalContent;
